import { useQueryClient } from '@tanstack/react-query';
import React from 'react';
import { usePreloadCardsQuery } from '../../../../../generated/core-api/graphql-react-query';

export default function useCardPreload(projectId: string | null) {
  const cards = usePreloadCardsQuery(
    { input: { id: projectId ?? '' } },
    { enabled: !!projectId, cacheTime: 30 * 60 * 1000 },
  );
  const queryClient = useQueryClient();

  React.useEffect(() => {
    cards.data?.getProject.scopes.items.forEach((scope) => {
      queryClient.setQueryData(
        ['getLiveCard', { cardId: scope.cardId, projectId }],
        { getCardInstance: scope },
      );
    });
  }, [cards.data, projectId, queryClient]);
}
